export const PointsLoyaltyActivity = (json: IPointLoyaltyActivity): IPointLoyaltyActivityModel => {
	const { starts_at, ends_at, actions, rules, updated_at, created_at, is_active, ...rest } = json

	return {
		...rest,
		isActive: is_active,
		startsAt: starts_at ? new Date(starts_at) : null,
		endsAt: ends_at ? new Date(ends_at) : null,
		actions: actions ? actions.map(action => PointsLoyaltyAction(action)) : [],
		rules: rules ? rules.map(rule => PointsLoyaltyRule(rule)) : [],
		updatedAt: updated_at ? new Date(updated_at) : null,
		createdAt: created_at ? new Date(created_at) : null,
	}
}

/**
 * Paylods
 */
const PointsLoyaltyActivitySharedPayload = (
	event: IFormSubmitEvent<IPointsLoyalityActivityForm>,
	other: IPointLoyaltyActivityPayloadOther,
): IPointsLoyaltyActivitySharedPayload => {
	const { startsAt, endsAt, name, description, isActive } = event.values

	const { isDateRange } = other

	const _startsAt = isDateRange && startsAt ? new Date(startsAt) : null
	const _endsAt = isDateRange && endsAt ? new Date(endsAt) : null

	return {
		name,
		description,
		starts_at: _startsAt,
		ends_at: _endsAt,
		is_active: isActive,
	}
}

export const PointsLoyaltyActivityToCreatePayload = (
	event: IFormSubmitEvent<IPointsLoyalityActivityForm>,
	other: IPointLoyaltyActivityPayloadOther,
): IPointLoyaltyActivityPayloadCreate => {
	const shared = PointsLoyaltyActivitySharedPayload(event, other)

	return {
		...shared,
	}
}

export const PointsLoyaltyActivityToUpdatePayload = (
	updated: IPointLoyaltyActivityModel,
	event: IFormSubmitEvent<IPointsLoyalityActivityForm>,
	other: IPointLoyaltyActivityPayloadOther,
): IPointsLoyaltyActivityPayloadUpdate => {
	const shared = PointsLoyaltyActivitySharedPayload(event, other)

	return {
		...shared,
		id: updated.id,
		name: updated.name,
		description: updated.description,
	}
}
